import { defineAsyncComponent } from 'vue';

export const teamReportMicroFrontends = {
	TeamReport: defineAsyncComponent(
		() => import('./components/TeamReport/TeamReport.vue')
	),
	TeamReportMetrics: defineAsyncComponent(
		() => import('./components/TeamReport/TeamReportMetrics.vue')
	),
};
